import { GetClaims, GetClaimsByFilter } from 'store/modules/claims/types';
import api, {
  certificatesApi,
  knowledgePortalApi,
  lossPreventionApi,
  trfRemApi,
} from './api';

export function getTRFREM(
  cpCode: number | string,
  franchiseCode: string,
  claimId: string,
) {
  return trfRemApi.post('/trf-rem/', [claimId], {
    headers: {
      'x-cpcode': `${cpCode}`,
      'x-franchise': franchiseCode,
    },
  });
}

export function getReports(cpCode: string, payload?: any) {
  return lossPreventionApi.get('/loss-prevention-reports/', {
    params: payload.payload,
    paramsSerializer: params => new URLSearchParams(params).toString(),
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': `${payload.stores}`,
    },
  });
}
export async function downloadReports(
  cpCode: number | string,
  franchiseCode: any,
  ids?: any,
  bucketKey?: string,
  idReport?: string,
): Promise<any> {
  return lossPreventionApi.post(
    `/loss-prevention-reports/signed-url`,
    bucketKey ? [{ idReport, bucketKey }] : ids,
    {
      headers: {
        'x-cpcode': `${cpCode}`,
        'x-franchise': franchiseCode,
      },
    },
  );
}

export function getCertificates(cpCode: string, payload?: any) {
  return certificatesApi.get('/certificates', {
    params: payload.payload,
    paramsSerializer: params => new URLSearchParams(params).toString(),
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': `${payload.stores}`,
    },
  });
}

export async function downloadCertificates(
  cpCode: number | string,
  franchiseCode: any,
  ids?: any,
  bucketKey?: string,
  idCertificate?: string,
): Promise<any> {
  return certificatesApi.post(
    `/certificates/file/signed-url`,
    bucketKey ? [{ idCertificate, bucketKey }] : ids,
    {
      headers: {
        'x-cpcode': `${cpCode}`,
        'x-franchise': franchiseCode,
      },
    },
  );
}

export function getKnowledgePortal(cpCode: string, payload?: any) {
  return knowledgePortalApi.get('/knowledge-hub', {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': payload,
    },
  });
}

export async function downloadKnowledgePortal(
  cpCode: number | string,
  franchiseCode: any,
  ids?: any,
  bucketKey?: string,
  idCertificate?: string,
): Promise<any> {
  return knowledgePortalApi.post(
    `/knowledge-hub/download/signedUrl`,
    bucketKey ? [{ idCertificate, bucketKey }] : ids,
    {
      headers: {
        'x-cpcode': `${cpCode}`,
        'x-franchise': franchiseCode,
      },
    },
  );
}

export function getClaims(
  cpCode: string,
  franchiseCode: string,
  payload?: GetClaims,
) {
  return api.get('/claims/', {
    params: payload,
    paramsSerializer: params => new URLSearchParams(params).toString(),
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function getStepsByClaimId(
  claimId: string,
  cpCode: string,
  franchiseCode: string,
) {
  return api.get(`/claims/${claimId}/timeline`, {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function searchClaims(cpCode: string, franchiseCode: string) {
  return api.get('/claims/search/', {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function getClaimStatus(cpCode: string, franchiseCode: string) {
  return api.get('/claims/status/', {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function getStates(cpCode: string, franchiseCode: string) {
  return api.get('/claims/states/', {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function deleteDraft(
  draftId: string,
  cpCode: string,
  franchiseCode: string,
) {
  return api.delete(`/claims/${draftId}/`, {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function getClaimById(
  id: string,
  cpCode: string,
  franchiseCode: string,
) {
  return api.get(`/claims/${id}/`, {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function getClaimsByFilter(
  cpCode: string,
  franchiseCode: string,
  payload?: GetClaimsByFilter,
) {
  return api.get('/claims/filter', {
    params: payload,
    paramsSerializer: params => new URLSearchParams(params).toString(),
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function getClaimsByBrokerFilter(
  cpCode: string,
  franchiseCode: string,
  payload?: GetClaimsByFilter,
) {
  return api.get('/claims/broker/filter', {
    params: payload,
    paramsSerializer: params => new URLSearchParams(params).toString(),
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function getStatusActionById(
  id: string,
  cpCode: string,
  franchiseCode: string,
) {
  return api.get(`/claims/${id}/statusActions`, {
    headers: {
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}

export function sendDocumentRequest(
  files: any,
  claimId: string,
  type: string,
  cpCode: string,
  franchiseCode: string,
  motive = '',
) {
  return api.post(`claims/${claimId}/send-request/`, files, {
    params: {
      motive,
      type,
    },
    headers: {
      'Content-Type': 'application/json',
      'x-cpcode': cpCode,
      'x-franchise': franchiseCode,
    },
  });
}
